// extracted by mini-css-extract-plugin
export default {"container":"GuideAssignees_container__zriU6","progress":"GuideAssignees_progress__b5BY1","none":"GuideAssignees_none__9OeBY","done":"GuideAssignees_done__GszkS"};